






























import { Component, Vue, Prop } from 'vue-property-decorator';
import QuestionTitle from './question-title.vue';
import MultiQuestionTitle from './multi-question-title.vue';
import MultiQuestionCheckbox from './multi-question-checkbox.vue';
import { Question } from '@/domains/template';
import { Record } from '@/domains/work';

import { commentsLevel } from '@/utils/excel/template/index';

@Component({
  name: 'MultiQuestion',
  components: {
    'question-title': QuestionTitle,
    'multi-question-title': MultiQuestionTitle,
    'multi-question-checkbox': MultiQuestionCheckbox,
  },
})
export default class MultiQuestion extends Vue {
  private commentsLevel: string;
  private checkModel: string = '0';
  @Prop()
  private value: Question;

  @Prop({ default: false })
  private save: boolean;

  @Prop()
  private record: Record;

  @Prop()
  private id: number | string;

  get question(): Question {
    return this.value;
  }

  set question(value: Question) {
    this.$emit('input', value);
  }

  get sum(): string {
    let sum: number = 0;
    this.question.questions.forEach((question: Question) => {
      sum += question.answer.answer ? parseInt(question.answer.answer, 10) * question.weigh / 100 : 0;
    });
    this.record.sumScore = sum.toFixed(2);
    this.commentsLevel = commentsLevel(sum);
    return sum.toFixed(2);
  }

  get remarks(): string {
    let remarks: string = '';
    if (!this.question) {
      return remarks;
    }
    remarks += '综合总分根据各指标的评价分数和权重（其中，';
    this.question.questions.forEach((question) => {
      remarks += question.base.name + question.weigh + '%、';
    });
    return remarks.substr(0, remarks.length - 1) + '）自动生成。';
  }
}
